import React, { Component } from 'react';
import './style.scss';
//import Icon from '../Icon/Icon';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { Link } from "react-router-dom";
import chevron from './chevron.png';
import InputWrap from './InputWrap';
import success_dt from './success-dt-en.png';
import success_dt_fr from './success-dt-fr.png';
import success_mb from './success-mb-en.png';
import success_mb_fr from './success-mb-fr.png';

import axios from 'axios';
const API_URL =  process.env.REACT_APP_API_URL;



  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <img src={chevron} alt="More" className="chevron" />
        </components.DropdownIndicator>
      )
    )
  }
   

class EmailSignup extends Component {
    state = {
        showForm: true,
        email_error: null,
        first_name_error: null,
        last_name_error: null,
        city_error: null,
        province_error: null,
        email: '',
        first_name: '',
        last_name: '',
        city: '',
        province: '',
        errorType: 'general',
        disabled: false,
    }



    checkForErrors = (allow_empty = false) => {
        // Clear errors
        this.setState({
            email_error: null,
            first_name_error: null,
            last_name_error: null,
            city_error: null,
            province_error: null,    
        });
        let ret = true;
        // Check the fields and set errors if necessary
        if (!allow_empty || this.state.email.length > 0) // Don't check if it's empty and we are allowing empties
        if (!this.state.email.includes('@') || !this.state.email.includes('.') || this.state.email.length < 3) {
            this.setState({email_error: this.props.lang == 'en' ? "Please enter a valid email address" : "veuillez inscrire une adresse courriel valide"});
            ret = false;
        }
        if (!allow_empty || this.state.first_name.length > 0)
        if ((this.state.first_name).length < 3) {
            this.setState({first_name_error: this.props.lang == 'en' ? "Please enter your first name" : "veuillez inscrire votre prénom"});
            ret = false;
        }
        if (!allow_empty || this.state.last_name.length > 0)
        if ((this.state.last_name).length < 3) {
            this.setState({last_name_error: this.props.lang == 'en' ? "Please enter your last name" : "veuillez inscrire votre nom de famille"});
            ret = false;
        }
        if (!allow_empty || this.state.city.length > 0)
        if (this.state.city.length < 3) {
            this.setState({city_error: this.props.lang == 'en' ? "Please enter your city for promotions where you live" : "veuillez inscrire votre ville pour recevoir les offres qui y sont en vigueur"});
            ret = false;
        }
        if (!allow_empty || this.state.city.length > 0)
        if (this.state.city.length >= 50) {
            this.setState({city_error: this.props.lang == 'en' ? "This city is too long" : "This city is too long"});
            ret = false;
        }
        if (!allow_empty || (this.state.province ?? '').length > 0)
        if ((this.state.province?.value ?? '').length != 2) {
            this.setState({province_error: this.props.lang == 'en' ? "Please enter your province for promotions where you live" : "veuillez inscrire votre province pour recevoir les offres qui y sont en vigueur"});
            ret = false;
        }
        return ret;
    }

    onsubmit = async (event) => {
        console.log("Form submitted");
        event.preventDefault();    

        try {
            // if error, show popup
            // otherwise, switch to bear
            if (!this.checkForErrors()) {
                console.log("There was an error")
                return;
            }
            this.setState({disabled: true});
            const response = await axios.post(`${API_URL}/api/email-signup`, {
                email: this.state.email,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                city: this.state.city,
                province: this.state.province.value,
                lang: this.props.lang
            });

            if (response.data.result == 'uniquenessConflict') {
                this.emailError();
            } else if (response.data.result == 'cardCreatedSuccess') {
                this.setState({showForm: false});                
            } else {
                this.generalError();
            }
        } catch(e) {
            console.log("error", e);
            this.generalError();
        }
        this.setState({disabled: false});
    }


    emailError = () => {
        this.props.toast(this.props.lang == 'en' ?
            <>Oops! This email address has already been used. <br />Please refresh the page and try again.</>
            :
            <>Oups! Cette courriel a déjà été utilisée. <br />Rafraîchissez la page et essayez à nouveau</>
        );
    }

    generalError = () => {
        this.props.toast(this.props.lang == 'en' ?
            <>Oops! Something went wrong with your email sign up. <br />Please refresh the page and try again.</>
            :
            <> Oups! Un problème est survenu avec votre inscription. <br />Rafraîchissez la page et essayez à nouveau</>
        );
    }

    setval = (e) => {
        const o = {};
        o[e.target?.name ?? 'province'] = e.target.value;
        this.setState(o);
        this.checkForErrors(true);
    }

    setselectval = (newValue, actionMeta) => {
        console.log(newValue, actionMeta);
        switch (actionMeta.action) {
            case 'remove-value':
            case 'pop-value':
                break;
            case 'clear':
                newValue = '';
                break;
        }
        this.setState({'province': newValue});
        this.checkForErrors(true);
    }


    render() {
        
        const en = this.props.lang == 'en';

        const provinces = [
            { value: 'AB', label: en ? 'Alberta' : 'Alberta' },
            { value: 'BC', label: en ? 'British Columbia' : 'Colombie-Britannique' },
            { value: 'MB', label: en ? 'Manitoba' : 'Manitoba' },
            { value: 'NB', label: en ? 'New Brunswick' : 'Nouveau-Brunswick' },
            { value: 'NL', label: en ? 'Newfoundland and Labrador' : 'Terre-Neuve-et-Labrador' },
            { value: 'NT', label: en ? 'Northwest Territories' : 'Territoires du Nord-Ouest' },
            { value: 'NS', label: en ? 'Nova Scotia' : 'Nouvelle-Écosse' },
            { value: 'NU', label: en ? 'Nunavut' : 'Nunavut' },
            { value: 'ON', label: en ? 'Ontario' : 'Ontario' },
            { value: 'PE', label: en ? 'Prince Edward Island' : 'Île-du-Prince-Édouard' },
            { value: 'QC', label: en ? 'Quebec' : 'Québec' },
            { value: 'SK', label: en ? 'Saskatchewan' : 'Saskatchewan' },
            { value: 'YT', label: en ? 'Yukon' : 'Yukon' }
          ];

        return (
            <div className="emailsignup">
                {this.props.lang == 'en' ?
                    <h2>Delicious A&W news <br className="mobile-only" />delivered to your inbox</h2>
                :
                    <h2>De savoureuses nouvelles <br className="mobile-only" />d’A&W dans votre boîte de réception</h2>
                }
                {this.props.lang == 'en' ?
                    <h3>Sign up for our email list</h3>
                :
                    <h3>Inscrivez-vous à notre liste d’envoi.</h3>
                }
                {this.state.showForm ?
                    <form onSubmit={this.onsubmit}>
                        <div className="p">
                            <InputWrap error={this.state.email_error} value={this.state.email} label={this.props.lang == 'en' ? "Email" : "Courriel" }>
                                <input type="text" name="email" onChange={this.setval} value={this.state.email} />
                            </InputWrap>
                        </div>
                        <div className="p">
                            <InputWrap error={this.state.first_name_error} value={this.state.first_name} label={this.props.lang == 'en' ? "First Name" : "Prénom" } >
                                <input type="text" name="first_name" onChange={this.setval} value={this.state.first_name} />
                            </InputWrap>
                            <InputWrap  error={this.state.last_name_error} value={this.state.last_name} label={this.props.lang == 'en' ? "Last Name" : "Nom de famille" }>
                                <input type="text" name="last_name" onChange={this.setval} value={this.state.last_name} />
                            </InputWrap>
                        </div>
                        <div className="p">
                            <InputWrap error={this.state.city_error} value={this.state.city} label={this.props.lang == 'en' ? "City" : "Ville" }>
                                <input type="text" name="city" onChange={this.setval} value={this.state.city} />
                            </InputWrap>
                            <InputWrap error={this.state.province_error} value={this.state.province?.value} label={this.props.lang == 'en' ? "Province" : "Province"} >
                                <Select
                                    className="provinces"
                                    closeMenuOnSelect={true}
                                    components={{ DropdownIndicator, IndicatorSeparator:() => null }}
                                    options={provinces}
                                    name="province"
                                    placeholder="  "
                                    onChange={this.setselectval}
                                    value={this.state.province}
                                />
                            </InputWrap>
                        </div>
                        <div className="buttonholder">
                            <input type="submit" disabled={this.state.disabled} value={this.props.lang == 'en' ? "Sign Up" : "S’inscrire"} title={this.props.lang == 'en' ? "Sign Up" : "Inscrivez-vous"} className="btn-submit" />
                            {this.props.lang == 'en' ?
                                <p className="copy">You can unsubscribe at any time by clicking the unsubscribe link at the bottom of an A&W email or by <Link className="white" to='/en/contact-us'>contacting us</Link>.</p>
                            :
                                <p className="copy">Vous pouvez vous désinscrire à tout moment en cliquant sur le lien au bas des courriels d’A&W ou en <Link className="white" to='/fr/contact-us'>nous contactant</Link>.</p>
                            }
                        </div>
                    </form>
                :
                    <>{this.props.isDesktop === true ?
                        <>{this.props.lang == 'en' ? 
                            <img src={success_dt} title="Success! You’ll now receive A&W’s special offers and news." className="success" />
                        :
                            <img src={success_dt_fr} title="Et voilà! À partir de maintenant, vous recevrez les offres spéciales et les nouvelles d’A&W." className="success" />
                        }</>
                    :
                        <>{this.props.lang == 'en' ? 
                            <img src={success_mb} title="Success! You’ll now receive A&W’s special offers and news." className="success" />
                        :
                            <img src={success_mb_fr} title="Et voilà! À partir de maintenant, vous recevrez les offres spéciales et les nouvelles d’A&W." className="success" />
                        }</>
                    }</>
                }
            </div>
        );
    }
}

export default EmailSignup;

